export default {
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
}
